/* TIK — geluidsknoppen voor de split-films.
   Los van tik-race.js gehouden: dat bestand beheert het afspelen van alle
   films, dit beheert alleen waar geluid uit komt. Zonder dit bestand blijven
   de films gewoon werken, ze spelen dan stil door. */
(function () {
  var btns = [].slice.call(document.querySelectorAll('[data-sound]'));
  if (!btns.length) return;

  var pairs = [];
  btns.forEach(function (btn) {
    var frame = btn.closest('.r-split-media');
    var film = frame && frame.querySelector('video');
    /* Geen film in dit kader: dan is een geluidsknop een loze belofte.
       Weghalen is eerlijker dan een knop die niets doet. */
    if (!film) { btn.parentNode.removeChild(btn); return; }
    pairs.push({ btn: btn, film: film });
  });

  function label(p) {
    p.btn.setAttribute('aria-pressed', String(!p.film.muted));
    p.btn.textContent = p.film.muted ? p.btn.dataset.on : p.btn.dataset.off;
  }

  /* Beide splits kunnen op een hoog scherm tegelijk in beeld staan en dus
     tegelijk spelen. Twee films die tegelijk geluid geven is kakofonie, dus
     er mag er altijd maar één aan staan: wie je aanzet, zet de ander uit. */
  function silenceOthers(keep) {
    pairs.forEach(function (p) {
      if (p === keep || p.film.muted) return;
      p.film.muted = true;
      label(p);
    });
  }

  pairs.forEach(function (p) {
    p.btn.addEventListener('click', function () {
      var wantSound = p.film.muted;
      if (wantSound) silenceOthers(p);
      p.film.muted = !wantSound;
      if (wantSound) {
        p.film.volume = 1;
        /* De klik is de gebruikersinteractie die de browser eist, dus dit mag
           nu. Weigert hij toch, dan zetten we hem terug op stil zodat de knop
           niet liegt over wat je hoort. */
        var pr = p.film.play();
        if (pr && pr.catch) {
          pr.catch(function () { p.film.muted = true; label(p); });
        }
      }
      label(p);
    });

    /* Scrollt de film uit beeld, dan pauzeert tik-race.js hem. Zet het geluid
       dan ook terug op stil: geluid dat doorloopt bij een video die je niet
       meer ziet is het irritantste wat een pagina kan doen. */
    p.film.addEventListener('pause', function () {
      if (p.film.muted) return;
      p.film.muted = true;
      label(p);
    });
  });
})();
